import type { AxiosInstance } from 'axios';
import type { paths } from '../schema';
import type { TimelineEntry } from '../types/timeline';
import type { RequestOptionsWithParams } from './types';
import { curry1 } from './utils';

type EmployeeTimelineEntry = TimelineEntry<
  Record<string, any>,
  | 'employee_created'
  | 'employee_verified'
  | 'employee_archived'
  | 'employee_unarchived'
  | 'employee_email_confirmed'
  | 'employee_password_updated'
  | 'employee_access_updated'
  | 'employee_email_suppressed'
>;

export type EmployeeHistoryParams = Required<
  paths['/api/employee/{employee_id}/history']['get']['parameters']
>['query'];

export type EmployeeHistory = Omit<
  paths['/api/employee/{employee_id}/history']['get']['responses']['200']['content']['application/json'],
  'results'
> & {
  results: EmployeeTimelineEntry;
};

export const getEmployeeHistory = async (
  instance: AxiosInstance,
  id: string,
  options?: RequestOptionsWithParams<EmployeeHistoryParams>
): Promise<EmployeeHistory> => {
  const res = await instance.get<EmployeeHistory>(
    `/employee/${id}/history`,
    options
  );

  return res.data;
};

export class EmployeeService {
  public getEmployeeHistory;

  constructor(private instance: AxiosInstance) {
    this.getEmployeeHistory = curry1(getEmployeeHistory)(this.instance);
  }
}
